module.exports = __webpack_public_path__ + "static/media/whatsapp.e196da40.png";